import Reveal from "@/components/base/Reveal";
import { downloadButtons } from "@/mocks/home";

export default function DownloadSection() {
  return (
    <section id="download" className="w-full bg-background-100">
      <div className="mx-auto max-w-shell px-4 py-16 md:px-6 md:py-24">
        <Reveal>
          <div className="relative w-full overflow-hidden rounded-lg bg-foreground-950">
            <div className="absolute inset-0">
              <img
                src="https://readdy.ai/api/search-image?query=abstract%20dark%20editorial%20backdrop%20with%20diagonal%20amber%20and%20crimson%20light%20streaks%20on%20charcoal%2C%20film%20grain%20texture%2C%20cinematic%20minimal%20composition%2C%20high%20contrast%2C%20no%20people&width=1600&height=700&seq=hl-download-2026&orientation=landscape"
                alt="31黑料网下载入口背景"
                title="31黑料网黑料导航 下载入口"
                className="h-full w-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-black/35" />
            </div>

            <div className="relative grid grid-cols-1 gap-10 px-6 py-12 md:grid-cols-12 md:px-12 md:py-16">
              <div className="md:col-span-8">
                <span className="inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/10 px-3.5 py-1.5 text-xs font-label text-white/90 backdrop-blur">
                  <i className="ri-download-2-line text-accent-400" />
                  下载入口 · 更新第一时间提醒
                </span>

                <h2 className="mt-5 font-heading text-2xl font-bold leading-snug text-white md:text-4xl">
                  装上入口条，
                  <br className="hidden md:block" />
                  黑料专题更新不再错过
                </h2>

                <p className="mt-4 max-w-xl text-sm leading-relaxed text-white/70 md:text-base">
                  下载后可直接在桌面入口查看黑料专题与黑料专区的最新条目，
                  更新有提醒、收藏有清单，追更只需要点一下。
                </p>

                <div className="mt-7 flex flex-col gap-3 sm:flex-row">
                  {downloadButtons.map((button, index) => (
                    <a
                      key={button.label}
                      href="#download"
                      className={`inline-flex items-center gap-3 whitespace-nowrap rounded-md px-5 py-3 transition-colors duration-300 cursor-pointer ${
                        index === 0
                          ? "bg-primary-500 text-background-50 hover:bg-primary-600 dark:text-foreground-950"
                          : "border border-white/25 bg-white/5 text-white hover:bg-white/15"
                      }`}
                    >
                      <i className={`${button.icon} text-xl`} />
                      <span className="flex flex-col leading-tight">
                        <span className="text-sm font-label font-medium">{button.label}</span>
                        <span className="text-[11px] opacity-70">{button.sub}</span>
                      </span>
                    </a>
                  ))}
                </div>
              </div>

              <div className="md:col-span-4 md:justify-self-end">
                <div className="flex w-full max-w-[220px] flex-col items-center rounded-lg border border-white/15 bg-white/10 p-6 backdrop-blur-md">
                  <span className="flex h-32 w-32 items-center justify-center rounded-md bg-white/90">
                    <i className="ri-qr-code-line text-6xl text-foreground-950" />
                  </span>
                  <p className="mt-4 text-center text-xs font-label leading-relaxed text-white/75">
                    扫码进入 <span className="text-accent-400">31黑料网</span>
                    <br />
                    黑料导航 · 移动端专用入口
                  </p>
                </div>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}